<template>
  <div class="home-menu">
    <div class="menu-catgory" v-for="(item, index) in menus" :key="`menu-catgory${index + 1}`">
      <div class="catgory-name" @click="goPath(item.path || null)" :style="{
        color: item.children ? 'rgba(255, 255, 255, .5)' : '#ffffff'
      }">
        {{ item.name }}
      </div>
      <div class="menu-subdivision">
        <div class="menu-subdivision-item" v-for="(it, i) in item.children" :key="`menu-subdivision-item${i + 1}`"
          @click="goPath(it.path || null)">
          {{ it.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/bus";
export default {
  name: "home-menu",
  data() {
    return {
      menus: [
        {
          name: "产品服务",
          children: [
            { name: "产品架构", path: "/productArchitecture" },
            { name: "认知智能算法平台", path: "/productCognitive" },
            { name: "工业级智能体", path: "/productManufacture" },
            // { name: "AI4Science", path: "/productDigitization" },
            // { name: "社会治理", path: "/productSociety" },
            { name: "运营决策智能体", path: "/operationDecision" }
          ]
        },
        {
          name: "技术生态",
          children: [
            { name: "核心技术", path: "/ecologicalCoreTechnology" },
            { name: "世界人工智能大会", path: "/ecologicalWaic" },
            { name: "研究院", path: "/ecologicalInstitute" }
          ]
        },
        {
          name: "华院新闻",
          path: "/news"
        },
        {
          name: "关于华院",
          path: "/about"
        },
        {
          name: "加入我们",
          path: "/addUs"
        }
      ]
    };
  },
  methods: {
    goPath(val) {
      if (!val) return;
      Bus.$emit("show-menu", false);
      Bus.$emit("logo-fixed-flag", false);
      this.$router.push(val);
    }
  }
};
</script>
<style lang="less" scoped>
.home-menu {
  position: fixed;
  width: calc(100% - 152px);
  height: 100vh;
  top: 0;
  padding: 142px 76px 0;
  background: rgba(9, 9, 50, 0.83);
  backdrop-filter: blur(10px);
  z-index: 8;

  .menu-catgory {
    .catgory-name {
      font-size: 26px;
      font-weight: 500;
      line-height: 36px;
      margin: 28px 0px 24px 0px;
    }

    .menu-subdivision {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: -8px;
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);

      .menu-subdivision-item {
        font-size: 26px;
        font-weight: 500;
        color: #ffffff;
        margin-right: 30px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue